<template>
  <!-- 此版本选择的是code -->
  <div class="classify_inner_box" v-if="filterObj">
    <!-- 标题 -->
    <div class="classify_lbox" v-if="filterObj.name">
      <span>{{filterObj.name}}:</span>
    </div>
    <!-- 默认全部 -->
    <div class="classify_tbox" v-if="filterObj.name">
      <span
        :class="{active:selctedIndex === -1,active2:filterObj.code==='sort'}"
        @click="changeSelcet(-1)"
      >全部</span>
    </div>
    <!-- 其他筛选条件 -->
    <ul class="classify_rbox">
      <!-- 是否显示全国 -->
      <li
        v-if="filterObj.showAllCountry"
        :class="{active:selctedIndex === -2}"
        @click="changeSelcetAllCountry"
      >全国</li>
      <!-- 筛选条件列表，会议室不显示 -->
      <!-- sort排序选中的样式不一样 active2 -->
      <li
        v-for="(item,index) in filterObj.list"
        :class="{active:selctedIndex === index,active2:filterObj.code==='sort'}"
        :key="index"
        @click="changeSelcet(index)"
      >{{item.name}}</li>
      <!-- 间隔文本框 -->
      <li class="classify_input_box" v-if="filterObj.range">
        <div class="classify_input">
          <input v-model="arg1" class="right_visit" @keyup.enter="classifyVal(arg1,arg2)" />
          <em>|</em>
          <input v-model="arg2" class="left_visit" @keyup.enter="classifyVal(arg1,arg2)" />
          <!-- <span class="unit">&nbsp;{{filterObj.range.unit}}</span> -->
        </div>
        <div class="btn" @click="changeSelcetAllCountry">确定</div>
      </li>
      <!-- 点击父分类查询子分类 -->
      <div class="child" v-if="filterObj.child && selctedIndex !== -1 && selctedIndex !== -2">
        <dl>
          <dd :class="{active:filterObj.child.selectIndex === -1}" @click="changeChildSelect(-1)">全部</dd>
          <dd
            v-for="it,idx in filterObj.child.list"
            :class="{active:filterObj.child.selectIndex === idx}"
            @click="changeChildSelect(idx)"
          >{{it.name}}</dd>
        </dl>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    filterObj: {
      type: Object
    },
    filedType: {
      type: String,
      default: "code"
    }
  },
  data() {
    return {
      selctedIndex: -1, //选中目标
      arg1: "", //输入框一
      arg2: "" //输入框二
    };
  },
  created() {
    this.selctedIndex = this.filterObj.name ? -1 : 0;
    this.selctedIndex =
      this.filterObj.defIndex >= 0
        ? this.filterObj.defIndex
        : this.selctedIndex;
  },
  computed: {
    //默认下标
    defIndex() {
      return this.filterObj.defIndex;
    }
  },
  watch: {
    //监听默认选择下标的改变
    defIndex(newVal, old) {
      this.selctedIndex = newVal >= 0 ? newVal : this.selctedIndex;
    }
  },
  methods: {
    /** 筛选了分类*/
    changeSelcet(index) {
      this.selctedIndex = index;
      let list =
        index === -1 ? [{ code: "", id: "" }] : this.filterObj.list[index]; //选择为全部
      let obj = {
        filedType: this.filedType,
        code: this.filterObj.code, //后台接口接收参数字段名称
        name: this.filterObj.name,
        list: list,
        child: this.filterObj.child, //是否有子字典
      };
      console.log(obj);
      this.$emit("selctedType", obj);
    },
    /** 筛选了子分类*/
    changeChildSelect(index) {
      this.filterObj.child.selectIndex = index;
      let list =
        index === -1
          ? [{ code: "", id: "" }]
          : this.filterObj.child.list[index]; //选择为全部
      let obj = {
        filedType: this.filterObj.child.filedType,
        code: this.filterObj.child.code, //后台接口接收参数字段名称
        name: this.filterObj.child.name,
        list: list
      };
      console.log(obj);
      this.$emit("selctedType", obj);
    },
    /** 点击了全国*/
    changeSelcetAllCountry() {
      this.selctedIndex = -2;
      let list = [{ code: "", id: "" }]; //选择为全部
      let obj = {
        filedType: this.filedType,
        code: this.filterObj.code, //后台接口接收参数字段名称
        name: this.filterObj.name,
        list: list,
        isAllCountry: true
      };
      this.$emit("selctedType", obj);
    },
    classifyVal(frontVal, laterVal) {
      let exp1 = new RegExp("^[1-9][0-9]*$").test(frontVal);
      let exp2 = new RegExp("^[1-9][0-9]*$").test(laterVal);
      if (exp1 && exp2 && Number(frontVal) <= Number(laterVal)) {
        this.$message({
          message: "输入格式正确,我要请求数据啦~",
          type: "success"
        });
      } else {
        this.$message.error("输入格式不正确");
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.classify_inner_box {
  &:last-child {
    border: none;
  }
  padding: 20px 0 12px 10px;
  display: flex;
  border-bottom: 1px #ddd dashed;
  span,
  li {
    display: block;
    font-size: 14px;
    color: #666;
    padding: 5px 9px 5px;
    border-radius: 2px;
  }
  .classify_lbox {
    min-width: 80px;
  }
  .classify_tbox {
    width: 54px;
    margin-right: 14px;
    text-align: center;
    span {
      cursor: pointer;
      white-space: nowrap;
    }
  }
  .classify_rbox {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    li {
      height: 25px;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
  span.active,
  li.active,
  li:not(.classify_input_box):hover,
  .classify_tbox > span:hover {
    background: #4c84ff;
    color: #fff;
  }
  .active.active2,
  .active.active2:hover,
  li.active2:hover {
    background: none;
    color: #4c84ff;
  }
  li.classify_input_box {
    width: 174px;
    height: 44px;
    margin-top:-4px;
    .classify_input {
      display: flex;
      align-items: center;
      width: 100px;
      height: 24px;
      border: 1px solid rgb(202, 188, 188);
      padding: 0 8px;
      background: #fff;
      box-sizing: border-box;
      em {
        width: 1px;
        height: 12px;
        background: rgba(151, 158, 165, 0.38);
      }
      .right_visit,
      .left_visit {
        width: 40px;
        border: none;
      }
      .unit {
        font-size: 14px;
        color: #666;
        cursor: default;
      }
    }
    .btn {
      display: block;
      font-size: 14px;
      color: #ffffff;
      width: 44px;
      height: 24px;
      background: #4c84ff;
      border-radius: 4px;
      text-align: center;
      line-height: 24px;
      display: none;
    }
  }
  li.classify_input_box:hover {
    display: flex;
    align-items: center;
    width: 174px;
    height: 44px;
    background: #ffffff;
    box-shadow: 0px 0px 9px 0px rgba(150, 158, 170, 0.32);
    margin-top:-7px;
    .classify_input {
      border: 1px solid #dddddd;
    }
    .btn {
      display: block;
      margin-left: 10px;
      flex:none;
    }
  }

  .child {
    width: 100%;
    background-color: rgb(247, 248, 249);
    padding: 10px 20px;
    dl {
      display: flex;
      flex-wrap: wrap;
    }
    dl dd {
      display: block;
      font-size: 14px;
      color: #666;
      padding: 5px 9px;
      border-radius: 2px;
      margin: 0 8px 6px 0;
      height: 25px;
      box-sizing: border-box;
      cursor: pointer;
    }
    dl dd:hover,
    dl dd.active {
      background: #4c84ff;
      color: #fff;
    }
  }
}
</style>
